
import styles from "./Contact.module.css"

export const Contactme = () => {

    return <div id="Contact" className={styles.container}>

        <div className={styles.top_section}>

            <div className={styles.left_section}>
                <div>
                    <p className={styles.heading}>Contact me.</p>
                    <div className={styles.connect}>
                        <a href="mailto:pratikjadhav@gmail.com"><img src="./icons/email.svg" alt="" /></a>
                        <p className={styles.email}>pratikjadhav080@gmail.com</p>
                    </div>
                    <div className={styles.connect}>
                        <a href="#"><img src="./icons/phone.svg" alt="" /></a>
                        <p className={styles.phone}> +91 9821747391</p>
                    </div>
                </div>

            </div>

            <div className={styles.right_section}>
                <div>
                    <form action="">
                        <div className={styles.catchylines}>
                            <p>Like what you see ?</p>
                            <p>Let’s work together !</p>
                        </div>
                        <div className={styles.inputbox}>
                            <input placeholder="Name" />
                            <input type="email" placeholder="Email" />
                            <input placeholder="Message" />
                        </div>
                        <input className={styles.sendbutton} type="Submit" value="SEND" />
                    </form>
                </div>
            </div>

        </div>
    </div>
}
